import { FormControlLabel, Switch } from '@mui/material';
import React from "react";
import {useTranslation} from "react-i18next";
import {CustomStyleSwitch} from "./Styles";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * @Description Switch with dynamic content
 * @param String id: Identifier for the Switch (required)
 * @param String name: Name for the Switch (optional)
 * @param Boolean disabled: Enable/disable Switch (optional)
 * @param String trans: Text for the label (optional)
 * @param Boolean checked: Is checked (required)
 * @param Boolean showBorder: Show border
 * @param Event onChange: onChange trigger in the Switch (required)
 * @returns {JSX.Element}
 */

export const CustomSwitch = ({id, name, disabled=false, trans, checked, onChange, labelPlacement='start', className='w-100', showBorder=true}) => {
    const { t } = useTranslation();

    return <>
        <FormControlLabel   sx={CustomStyleSwitch(showBorder, disabled)} className={`ibl-font-w-300 fs-14px ${className}`} control={
                            <Switch
                                id={id}
                                name={name}
                                disabled={disabled}
                                checked={checked}
                                onChange={onChange}
                            />
            }
            label={t(trans)}
            labelPlacement={labelPlacement}
        />

    </>
}
